// adds text field from input to list of type +/-
export const addText = (text, type, setter) => {
    if(type === '+') {
        setter(plusList => [...plusList, text])
    } else if (type === '-') {
        setter(minusList => [...minusList, text])
    } else {
        console.log('addText fail')
    }
}

// removes text field from list of type +/-
export const removeText = (type, removeIndex, setter) => {
    if(type === '+') {
        setter(plusList => plusList.filter((_val, index) => index !== removeIndex))
    } else if(type === '-') {
        setter(minusList => minusList.filter((_val, index) => index !== removeIndex))
    } else {
        console.log('removeText fail')
    }
}

// randomize array in-place using Durstenfeld shuffle algorithm
export const shuffle = (array) => {
    for (var i = array.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var temp = array[i];
        array[i] = array[j];
        array[j] = temp;
    }
    return array
}

// calculates average from array
export const average = (array) => array.reduce((a, b) => a + b) / array.length

// return current date formatted to FI
export const getFormattedDate = () => {
    var today = new Date()
    var dd = String(today.getDate()).padStart(2, '0')
    var mm = String(today.getMonth() + 1).padStart(2, '0') //January is 0!
    var yyyy = today.getFullYear()

    const date = dd + '.' + mm + '.' + yyyy

    return date
  }